import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const liabilities: AnswerPathTreeNode = {
  path: 'liabilities',
  children: [
    { path: 'mortgageBalanceAmount', nodeId: NodeIds.liabilitiesMortgageBalanceAmount },
    { path: 'totalDebtAmount', nodeId: NodeIds.liabilitiesTotalDebtAmount },
  ],
};
